<p>
  applied-filter-tag works!
</p>
